import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import {gql} from "@irati/utils/gql"

export const listPayrollOrdersQuery = gql`
  query ListPayrollOrders(
    $first_name: String
    $last_name: String
    $organisation_approval: String
    $order_status: String
    $employee_number: String
    $ni_number: String
    $pay_frequency: String
    $payroll_period: String
    $orders_date_from: String
    $orders_date_to: String
    $benefit_type: String
    $page: Int
  ) {
    listPayrollOrders(
      first_name: $first_name
      last_name: $last_name
      organisation_approval: $organisation_approval
      order_status: $order_status
      employee_number: $employee_number
      ni_number: $ni_number
      pay_frequency: $pay_frequency
      payroll_period: $payroll_period
      orders_date_from: $orders_date_from
      orders_date_to: $orders_date_to
      benefit_type: $benefit_type
      page: $page
    ) {
      orders {
        id
        client_id
        employee_id
        title
        first_name
        surname
        email
        effective_date
        total_amount_to_recover
        amount_per_pay_period
        order_number
        duration
        benefit_type
        mobile_number
        address1
        address2
        city
        county
        postcode
        ni_number
        date_of_birth
        job_title
        job_location
        job_grade
        partner_user_identifier
        approval_status
        order_status
        basic_details_check_complete
        order_details_check_complete
        national_minimum_wage_check_complete
        telephone_number
        benefit_name
        total_end_of_agreement_inc_vat
        pay_frequency
        products {
          item_no
          item_name
          item_description
          item_qty
          item_value
        }
        line_manager_name
        line_manager_email
        comments {
          name
          comment
          partner_user_id
          created_at
          partnerUser {
            uuid
          }
        }
      }
      scheme_types_by_count {
        name
        value
      }
    }
  }
`

export const getListPayrollOrdersQueryKey = getQueryNames(listPayrollOrdersQuery)[0]
